import React, { Component } from 'react';
import Dialog from './../UiComponents/Dialog';
import PropTypes from 'prop-types';
import getLabel from './../../utils/labels'
import styles from './tutorialEndPopup.module.scss';

class TutorialEndPopup extends Component {
    goToTutorialEndPage = () => {
        window.location.href = window.location.href.split('/').slice(0, -2).join('/') + '/tutorial-end';
    }

    render() {
        return (
            <Dialog overlayClassName={styles.dialog} isFooterNeeded={false}>
                <div className={styles.container}>
                    <div className={styles.message}>
                        <div className={styles.boldtext}>
                            {getLabel('label_tutorial_completed_message')}
                        </div>
                    </div>
                    <div className={styles.buttons}>
                        <div className={styles.closeButton} onClick={this.goToTutorialEndPage}>{getLabel('label_continue_button')}</div>
                    </div>
                </div>
            </Dialog>
        )
    }
}

export default TutorialEndPopup


// WEBPACK FOOTER //
// /src/components/tutorialEndPopup/TutorialEndPopup.js